export default __webpack_public_path__ + "rpl_co_brand_light.56633c1c.svg";